<template>
  <b-card
    class="w-full flex rounded-lg h-83vh cust-overflow-y-primary-color-grey scope-padding"
  >
    <div class="w-full bg-white rounded-xl">
      <div class="parent">
        <b-tabs content-class="" justified class="root cust-of">
          <!-- <b-tab 
            ><template #title>
              <div class="p-1">
                <img src="./img/profile.png" class="mx-auto h-10 w-10" />
                <p class="pt-1 font-semibold">UIUX designer</p>
              </div>
            </template>
            <p><BAnalyst /></p>
          </b-tab> -->
          <b-tab active class="helo"
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/Project Manager.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">Project Manager</p>
              </div>
            </template>
            <ProjectManager class="overflow-x-auto" />
          </b-tab>
          <b-tab
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/Business Analyst.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">Business Analyst</p>
              </div>
            </template>
            <p><BAnalyst /></p>
          </b-tab>
          <b-tab
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/UX Designer.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">UX designer</p>
              </div>
            </template>
            <p><UX /></p>
          </b-tab>
          <!-- <b-tab
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/Graphic Designer.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">Graphic Designer</p>
              </div>
            </template>
            <p>I'm the second tab</p></b-tab
          > -->
          <b-tab
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/Web Developer.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">Web Developer</p>
              </div>
            </template>
            <WebDeveloper
          /></b-tab>
          <b-tab
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/Mobile App Developer.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">Mobile App Developer</p>
              </div>
            </template>
            <MobileAppDeveloper
          /></b-tab>
          <b-tab
            ><template #title>
              <div class="p-1">
                <img src="./img/avatars/DBA.png" class="mx-auto h-10 w-10" />
                <p class="pt-1 font-semibold">DBA</p>
              </div>
            </template>
            <p>I'm the tab with the very, very long title</p></b-tab
          >
          <b-tab
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/Cloud Architect.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">Cloud Architect</p>
              </div>
            </template>
            <p><CloudArch /></p
          ></b-tab>

          <b-tab
            ><template #title>
              <div class="p-1">
                <img
                  src="./img/avatars/QA Tester.png"
                  class="mx-auto h-10 w-10"
                />
                <p class="pt-1 font-semibold">QA Tester</p>
              </div>
            </template>
            <QATester />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";
import BAnalyst from "./tabs/BAnalyst.vue";
import CloudArch from "./tabs/cloudArch/CloudArch.vue";
import MobileAppDeveloper from "./tabs/MobileAppDeveloper/MobileAppDeveloper.vue";
import QATester from "./tabs/QAtest/QATester.vue";
import ProjectManager from "./tabs/projectmanage/ProjectManager.vue";
import UX from "./tabs/UX/UX.vue";
import TableTagsData from "./components/TableTagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import VendorTable from "./components/VendorTable";
import AddTagsSidebar from "./components/AddTagsSidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import WebDeveloper from "./components/WebDeveloper.vue";

export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    AddTagsSidebar,
    VendorTable,
    BAnalyst,
    UX,
    QATester,
    MobileAppDeveloper,
    ProjectManager,
    CloudArch,
    WebDeveloper
  },
  data() {
    return {
      TagsData,
      TableTagsData,
      currentPage: 1,
      // editModal: false,
      tableModal: false,
      openAddBannerSidebar: false,
      selectedName: ""
    };
  },
  computed: {
    currentRoute() {
      return this.$router;
    }
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    handleClick({ route }) {
      this.$router.push({ name: route });
    }
  },

  created() {
    let recaptchaScript = document.createElement("script");

    recaptchaScript.setAttribute("src", "./chat.js");

    document.head.appendChild(recaptchaScript);
  }
};
</script>
<style>
.p-0card > .card-body {
  padding: 0px !important;
}
.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-top: 10px solid #830c81;
  background-color: rgb(255, 255, 255);
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  width: 250px;
  background-color: #f3f3f3;
}
/* .root > div > .nav-tabs .nav-link {
  width: 250px;
} */
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
/* .root > div > .nav .nav-tabs .nav-justified > .nav-item {
  background-color: #830c81;
} */

.root > div > .nav {
  flex-wrap: nowrap !important;

  overflow-y: hidden;
  background-color: #f3f3f3;
}

/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}
</style>
